import React, { useEffect, useState } from 'react';
import { Button, message, Space } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { Link, useParams } from 'react-router-dom';
import { inventoryOrder } from './api';
import CpLoading from '../../components/CpLoading';
import { IndexToStatusText } from './utils/common';
import CpProductInfo from '../../components/CpProductInfo';
import { amountToString } from '../../util/tool';
import './style.less';

const arrival_type_config = {
  '1': '次日达',//
  '2': '隔日达',
};

export default function ProposalDetail() {
  const { id } = useParams();
  const [orderInfo, setOrderInfo] = useState({});
  const [loading, setLoading] = useState(true);
  // const columns = [
  //   {
  //     title: '商品信息',
  //     dataIndex: 'sale_name',
  //     key: 'sale_name',
  //     render: (text, record) => {
  //       return <CpProductInfo  showUnit product={{ ...record, sale_norms: record.sale_unit }} toProductDetail={() => { toProductDetail(record); }} />;
  //     }
  //   },
  //   {
  //     title: '数量',
  //     dataIndex: 'number',
  //     key: 'number',
  //     align: 'center',
  //   },
  // ];

  const columns = [
    { key: 'product', name: '商品', align: 'left', colSpan: 2 },
    { key: 'norms_price', name: '单价(元)', align: 'center' },
    { key: 'number', name: '订货数量', align: 'center' },
    { key: 'receive_number', name: '已收货数量', align: 'center' },
    { key: 'un_receive_number', name: '未收货数量', align: 'center' },
    // { key: 'tax_rate', name: '税率', align: 'center' },
    // { key: 'tax_inclusive_price', name: '商品价格(含税)', align: 'center' },
    // { key: 'number', name: '数量', align: 'center' },
    { key: 'norms_price_total', name: '金额', align: 'center' },
    { key: 'total', name: '总计', align: 'center' },
  ];



  useEffect(() => {
    async function getOrderDetail() {
      const { data: { data, msg, code } } = await inventoryOrder({ order_no: id });
      if (+code === 0) {
        setOrderInfo(data);
        setLoading(false);
      } else {
        message.error(msg);
      }
    }
    getOrderDetail();
  }, [id]);
  return (
    <>
      {loading ? <CpLoading size="large" className="cp-loading" /> :
        <div className="order-detail proposal-order-detail">
          <Space className='mb-20' split={<RightOutlined />}>
            <Link to={{ pathname: '/basic/user/order' }}>我的订货单</Link>
            <span>订货单号：{orderInfo.order_no}</span>
          </Space>
          <div className="order-process">
            <div className="order-process-content">
              <div>订货单号：{orderInfo.order_no}</div>
              <div>状态:<Button type='link'> {IndexToStatusText[+orderInfo.order_status]}</Button></div>
            </div>
          </div>
          <div className="order-detail-info">
            <div className="order-detail-info-item">
              <div className="item mb-20"><span>创建时间：</span>{orderInfo.create_time}</div>
              <div className="item mb-20"><span>期望到货时间：</span>{orderInfo.expected_time}</div>
              <div className="item mb-20"><span>供应商：</span>{orderInfo.supplier_name}</div>
              <div className="item mb-20"><span>到货类型：</span>{arrival_type_config[`${orderInfo?.arrival_type}`]}</div>
            </div>
            <div className="order-detail-info-item">
              <div className="item mb-20"><span>收货人：</span>{orderInfo.consignee_name}</div>
              <div className="item mb-20"><span>收货地址：</span>{orderInfo.country_name}{orderInfo.province_name}{orderInfo.city_name}{orderInfo.district_name}{orderInfo.address}</div>
              <div className="item mb-20"><span>手机号：</span>{orderInfo.consignee_mobile}</div>
            </div>
          </div>

          <div className="order-product-list">
            <table className="cp-table">
              <thead>
                <tr>
                  {
                    columns.map((item, index) => {
                      return (
                        <th key={index} colSpan={item.colSpan || 1} style={{ textAlign: item.align, textIndent: index === 0 ? '20px' : '' }}>
                          {item.name}
                        </th>
                      );
                    })
                  }
                </tr>
              </thead>
              <tbody>
                {
                  orderInfo?.product?.map((item, index) => {
                    return (
                      <tr key={index}>
                        {
                          columns.map((col, index) => {
                            if (col.key === 'product') {
                              return (
                                <td key={index} colSpan={2} style={{ maxWidth: '200px' }}>
                                  <div className="p-info">
                                    <CpProductInfo showUnit product={{ ...item, sale_norms: item.sale_unit }} toProductDetail={() => { this.toProductDetail({ ...item, sale_norms: item.sale_unit }); }} />
                                  </div>
                                </td>
                              );
                            } else if (col.key === 'number') {
                              return (
                                <td key={index} style={{ textAlign: 'center', fontWeight: '600' }}>
                                  <div>x{+item.number}</div>
                                  {/* <div>{this.renderNumberPopover(item)}</div> */}
                                </td>
                                // <td key={index} style={{ textAlign: 'center', fontWeight: '600' }}>x{+item.sale_number}</td>
                              );
                            } else if (col.key === 'receive_number') {
                              return (
                                <td key={index} style={{ textAlign: 'center', fontWeight: '600' }}>
                                  <div>{+item.receive_number}</div>
                                </td>
                              );
                            } else if (col.key === 'un_receive_number') {
                              return (
                                <td key={index} style={{ textAlign: 'center', fontWeight: '600' }}>
                                  <div>{item.number - item.receive_number}</div>
                                </td>
                              );
                            } else if ((col.key === 'norms_price')) {
                              return (<td key={index} style={{ textAlign: 'center', fontWeight: '600' }}>￥{amountToString(item.norms_price)}</td>);
                            } else if (col.key === 'tax_rate') {
                              return (<td key={index} style={{ textAlign: 'center', fontWeight: '600' }}>{item.tax_rate >= 0 ? (+item.tax_rate + '%') : '-'}</td>);
                            } else if (col.key === 'tax_inclusive_price') {
                              return (<td key={index} style={{ textAlign: 'center', fontWeight: '600' }}>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>{item.tax_inclusive_price === '-' ? '' : <>￥{amountToString(item.tax_inclusive_price)}</>}{this.renderDetail(item.surcharge_desc)}</div>
                              </td>);
                            } else if ((col.key === 'norms_price_total')) {
                              return (<td key={index} style={{ textAlign: 'center', fontWeight: '600' }}>￥{amountToString(+item.norms_price_total)}</td>);
                            } else {
                              return null;
                            }
                          })
                        }
                        {index === 0 ? (<td key={index} rowSpan={orderInfo.product.length} style={{ textAlign: 'center', fontWeight: '600', borderLeft: '1px solid #e9e9e9' }}>￥{amountToString(+orderInfo.order_price)}</td>) : null}
                      </tr>
                    );
                  })
                }
              </tbody>
            </table>
          </div>
          {/* <Table
            columns={columns}
            dataSource={orderInfo?.product || []}
            pagination={false}
            rowKey='id'
          /> */}
        </div>}
    </>
  );
}
